import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {CentralizeEmails} from './pages/centralize-emails';
import {GenerateLeadsInsights} from './pages/generate-leads-insights';
import {InternalNotesTemplates} from './pages/internal-notes-templates';

export function SharedEmailInboxLearnMoreModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.SHARED_EMAIL_INBOX_LEARN_MORE_MODAL);

    const pages = [
        {
            id: 'centralize-emails',
            body: <CentralizeEmails />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='shared-email-inbox-onboarding/centralize-emails'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
        {
            id: 'internal-notes-templates',
            body: <InternalNotesTemplates />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='shared-email-inbox-onboarding/internal-notes-templates'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
        {
            id: 'generate-leads-insights',
            body: <GenerateLeadsInsights />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='shared-email-inbox-onboarding/generate-leads-insights'
                                width={280}
                            />
                        }
                        width={280}
                    />
                ),
            },
        },
    ];

    return (
        isOpen && (
            <OnboardingModal
                trapFocus={false}
                lastButtonText='Done'
                pages={pages}
                onClose={onClose}
                onFinish={onClose}
            />
        )
    );
}
